import apiClient from "../../client/apiClient"

export type Address = {
  _id: string
  city: string
  area: string
  buildingName: string
  blockNo: string
  houseNo: string
  createdAt: string
  updatedAt: string
}

export type UserProfile = {
  _id: string
  firstName: string
  lastName: string
  email: string
  phoneNumber: string
  address: Address
  status: string
  branch: string
  isDeleted: boolean
  createdAt: string
  updatedAt: string
  employeeID: null
  lastLogin: string
  role: string
  profilePicture?: string
}

export type UpdateProfileData = {
  firstName?: string
  lastName?: string
  phoneNumber?: string
  address?: {
    city?: string
    area?: string
    buildingName?: string
    blockNo?: string
    houseNo?: string
  }
}

export type ChangePasswordData = {
  currentPassword: string
  newPassword: string
}

export type ApiResponse = {
  success: boolean
  data: UserProfile
  message?: string
}

const PROFILE_ENDPOINT = {
  PROFILE: "/auth/me",
  UPDATE_PROFILE: "/auth/me",
  CHANGE_PASSWORD: "/auth/change-password",
}

const getProfile = async (): Promise<UserProfile> => {
  const response = await apiClient({
    url: PROFILE_ENDPOINT.PROFILE,
    method: "GET",
  })
  return response.data.data
}

const updateProfile = async (
  profileData: UpdateProfileData | FormData
): Promise<UserProfile> => {
  const config: any = {
    url: PROFILE_ENDPOINT.UPDATE_PROFILE,
    method: "PUT",
  }

  if (profileData instanceof FormData) {
    config.data = profileData
  } else {
    config.data = profileData
  }

  const response = await apiClient(config)
  return response.data.data
}

const changePassword = async (
  passwordData: ChangePasswordData
): Promise<{ success: boolean; message: string }> => {
  try {
    const response = await apiClient({
      url: PROFILE_ENDPOINT.CHANGE_PASSWORD,
      method: "PUT",
      data: passwordData,
    })
    return response.data
  } catch (error: any) {
    if (error.response?.data) {
      throw error.response.data
    }
    throw {
      success: false,
      message: "Network error occurred",
    }
  }
}

const uploadProfilePicture = async (file: File): Promise<UserProfile> => {
  const formData = new FormData()
  formData.append("profilePicture", file)

  const response = await apiClient({
    url: PROFILE_ENDPOINT.UPDATE_PROFILE,
    method: "PUT",
    data: formData,
  })
  return response.data.data
}

export { getProfile, updateProfile, changePassword, uploadProfilePicture }
